import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { EventBusService } from './event-bus.service';
import { EventData } from '../shared/classes/EventData';
import { LocalService } from './database/local.service';

@Injectable({
  providedIn: 'root'
})
export class UserActivityService {

  private inactivityTimeout: any;
  private readonly inactivityDuration = 3600000; // 1 hora
  private activitySubject = new Subject<void>();
  
  constructor(private _ebs: EventBusService, private _ls: LocalService) {
    this.resetInactivityTimer();
    this.activitySubject.subscribe(() => this.resetInactivityTimer());
  }

  resetInactivityTimer() {
    clearTimeout(this.inactivityTimeout);
    if(!this._ls.isLoggedIn) {
      return;
    }
    this.inactivityTimeout = setTimeout(() => this.showInactivityDialog(), this.inactivityDuration);
  }

  notifyActivity() {
    this.activitySubject.next();
  }

  private showInactivityDialog() {
    this._ebs.emit(new EventData('no-user-activity', null));
    
  }
}
